export const otpContents = {
  labels: {
    otpField: "Enter OTP",
    verified: "Verified"
  },
  placeholders: {
    otp: "Enter the Otp"
  },
  buttons: {
    generateOtp: "Generate OTP",
    resendOtp: "Resend OTP",
    verifyOtp: "Verify OTP"
  },
  feedbacks: {
    registerOtpSuccess:
      "OTP has been sent successfully over SMS. It will expire in 3 minutes.",
    loginOtpSuccess:
      "OTP has been sent successfully over e-mail and SMS. It will expire in 3 minutes.",
    verifySuccess: "Phone number has been verified successfully."
  }
};

export enum StatusTypes {
  new = "new",
  generated = "generated",
  verified = "verified"
}
export const maxAttempts = 3;
export const otpLength = 4;
